import _en from './translations/en.json.mjs';
import React__default, { useState } from 'react';
import { Popover, ActionList, Tooltip } from '@shopify/polaris';
import { MenuHorizontalIcon } from '@shopify/polaris-icons';
import { useI18n } from '@shopify/react-i18n';
import styles from './RollupMenu.scss.mjs';
import { PlainAction } from '../PlainAction/PlainAction.mjs';

function RollupMenu({
  outline,
  label,
  accessibilityLabel,
  vertical,
  tooltip,
  slim,
  ...props
}) {
  const [i18n] = useI18n({
    id: 'RollupMenu_qe4e8x',
    fallback: _en,
    translations(locale) {
      if (["cs", "da", "de", "es", "fi", "fr", "it", "ja", "ko", "nb", "nl", "pl", "pt-BR", "pt-PT", "sv", "th", "tr", "vi", "zh-CN", "zh-TW"].indexOf(locale) < 0) {
        return;
      }
      return import( /* webpackChunkName: "RollupMenu_qe4e8x-i18n", webpackMode: "lazy-once" */`./translations/${locale}.json`).then(dict => dict && dict.default);
    }
  });
  const [menuIsActive, setMenuIsActive] = useState(false);
  const handlePopoverToggle = () => setMenuIsActive(wasActive => !wasActive);
  const onDeactivate = () => setMenuIsActive(false);
  const activator = /*#__PURE__*/React__default.createElement(PlainAction, {
    content: label,
    outline: outline,
    vertical: vertical,
    slim: slim,
    icon: MenuHorizontalIcon,
    ariaExpanded: menuIsActive,
    accessibilityLabel: accessibilityLabel != null ? accessibilityLabel : i18n.translate('RollupMenu.viewActions'),
    onAction: handlePopoverToggle
  });
  const activatorMarkup = tooltip ? /*#__PURE__*/React__default.createElement(Tooltip, {
    content: tooltip,
    preferredPosition: "above"
  }, activator) : activator;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ControlledRollupMenu, Object.assign({}, props, {
    menuIsActive: menuIsActive,
    activator: activatorMarkup,
    onDeactivate: onDeactivate
  })));
}
function ControlledRollupMenu({
  header,
  sections,
  menuIsActive,
  onDeactivate,
  activator
}) {
  const headerMarkup = header ? /*#__PURE__*/React__default.createElement("div", {
    className: styles.Header
  }, header) : null;
  return /*#__PURE__*/React__default.createElement(Popover, {
    active: menuIsActive && hasSectionsWithItems(sections),
    activator: activator,
    preferredAlignment: "right",
    onClose: onDeactivate
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.RollupMenu
  }, headerMarkup, /*#__PURE__*/React__default.createElement(ActionList, {
    sections: sections,
    onActionAnyItem: onDeactivate
  })));
}
function hasSectionsWithItems(sections) {
  return sections == null || sections.length === 0 ? false : sections.some(section => section.items.length > 0);
}

export { ControlledRollupMenu, RollupMenu, hasSectionsWithItems };
